import { connect } from 'react-redux';
import { getSocketConnectionStatus } from './../reducers';
import { messaging, urls } from '../helpers';
import ClickableImageComponent
  from './../Components/ClickableImageComponent.jsx';

export const mapStateToProps = (state) => {
  const connected = getSocketConnectionStatus(state);
  return {
    isActive: connected,
    activeImageSource: urls.SERVER_CONNECTED_SRC,
    disabledImageSource: urls.SERVER_DISCONNECTED_SRC,
    activeHoverText: messaging.SERVER_CONNECTED_HOVERTEXT,
    disabledHoverText: messaging.SERVER_DISCONNECTED_HOVERTEXT,
    height: 25,
    marginRight: '-10px'
  };
};

export default connect(
  mapStateToProps
)(ClickableImageComponent);



// WEBPACK FOOTER //
// src/Containers/WebsocketConnectionContainer.jsx